import { render } from "./StudentSessionOverview.vue?vue&type=template&id=10c69890"
import script from "./StudentSessionOverview.vue?vue&type=script&lang=js"
export * from "./StudentSessionOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__